import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

type StyledSelectorType = { 'data-styled-selector'?: string };

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.div({
	minHeight: '19px',
	maxHeight: '38px',
	display: '-webkit-box',
	WebkitLineClamp: '2',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	font: token('font.heading.xsmall'),
	color: token('color.text'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Description = styled.div({
	marginTop: token('space.050'),
	minHeight: '16px',
	maxHeight: '64px',
	display: '-webkit-box',
	WebkitLineClamp: '4',
	WebkitBoxOrient: 'vertical',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	font: token('font.body.small'),
	color: token('color.text.subtlest'),
	fontWeight: token('font.weight.regular'),
});

const itemContainerSelector = 'template-card.ItemContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ItemContainer = styled.div<StyledSelectorType>({
	position: 'absolute',
	right: token('space.025'),
	top: token('space.025'),
	float: 'right',
});
ItemContainer.defaultProps = {
	'data-styled-selector': itemContainerSelector,
};

const starContainerSelector = 'template-card.StarContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StarContainer = styled.button<
	{
		isVisible?: boolean;
	} & StyledSelectorType
>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	opacity: (props) => (props.isVisible ? 1 : 0),
	border: '0 none',
	background: 'transparent',
	padding: 0,
	cursor: 'pointer',
	float: 'right',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	svg: {
		borderRadius: token('radius.full'),
		willChange: 'transform',
	},
	'&:focus': {
		opacity: 1,
	},
	'&:disabled': {
		cursor: 'inherit',
	},
});
StarContainer.defaultProps = {
	'data-styled-selector': starContainerSelector,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DescriptionContainer = styled.div({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	span: {
		marginTop: token('space.050'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TitleContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	gap: token('space.075'),
	marginTop: token('space.negative.050'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AvatarContainer = styled.div({
	position: 'relative',
	marginBottom: token('space.200'),
	'&:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		[`[data-styled-selector="${starContainerSelector}"]`]: {
			opacity: 1,
		},
	},
});
